import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Score from './Score';

export default
class LeaderboardScoreTotal extends Component {
    static propTypes = {
        scoreStyle: PropTypes.object.isRequired,
        athlete: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired
    };

    render() {
        const {
            scoreStyle,
            athlete,
            colors,
            children
        } = this.props;

        const style = athlete.isLive
            ? colors.active
            : colors.default;

        return (
            <div className="score total">
                <Score
                    key={`leaderboard_total_${athlete.externalId}`}
                    style={{
                        ...style,
                        ...scoreStyle
                    }}
                >
                    {children}
                </Score>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/scores/Total.js